/**
 * Logged-in home (user dashboard). The package detail `StoreBanner` "Back"
 * control always navigates here so users return to the same home view after
 * opening a package from any dashboard banner or promo.
 */
export const LOGGED_USER_DASHBOARD_PATH = "/user_dashboard";

/**
 * Used by package detail `StoreBanner` — keeps "Back" behaviour in one place.
 * @param {{ push: (path: string) => void }} history - react-router `useHistory()`
 */
export function goToLoggedUserDashboardFromPackagePage(history) {
  if (history && typeof history.push === "function") {
    history.push(LOGGED_USER_DASHBOARD_PATH);
  }
}

/**
 * Navigate from the logged-in **user dashboard** (banners, sliders, promos,
 * combo blocks, etc.). Prefer this over ad-hoc `history.push` for in-app routes
 * opened from the dashboard so behaviour stays aligned with package-page back.
 *
 * Examples:
 *   navigateFromUserDashboardBanner(history, `/package/${id}`);
 *   navigateFromUserDashboardBanner(history, { pathname: "/ots", state: { tab: "ots" } });
 *   navigateFromUserDashboardBanner(history, "/store", { targetModuleId: "123" }); // second arg is location.state for /store
 *
 * @param {{ push: (to: string | object, state?: object) => void }} history
 * @param {string | { pathname: string, search?: string, state?: object }} to
 * @param {object} [locationState] - only when `to` is a string path for `/store` with `history.push(path, state)` style
 */
export function navigateFromUserDashboardBanner(history, to, locationState) {
  if (!history || typeof history.push !== "function") return;

  if (typeof to === "string") {
    if (locationState !== undefined) {
      history.push(to, locationState);
    } else {
      history.push(to);
    }
    return;
  }

  history.push(to);
}
